import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateUsergroupState from './updateUsergroup';
import createUserGroupState from './createUsergroup';
import deleteUserGroupState from './deleteUsergroup';
import readUserGroupState from './readUsergroup';
import updateUserGroupUsersState from './usergroupUsers';
import updateUserUserGroupState from './userUsergroups';
import updateUserState from './user';
import updateRoleState from './role';
import updateTaskState from './task';

const handlers = {
  ...updateUsergroupState,
  ...createUserGroupState,
  ...deleteUserGroupState,
  ...readUserGroupState,
  ...updateUserGroupUsersState,
  ...updateUserUserGroupState,
  ...updateUserState,
  ...updateRoleState,
  ...updateTaskState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
